"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewLink = void 0;
const apollo_link_1 = require("apollo-link");
const renewModal_1 = require("../utils/renewModal");
const auth_1 = require("../logic/auth");
const tracking_1 = require("@food/tracking");
const track_1 = require("../utils/track");
const RenewLink = (auth) => class extends apollo_link_1.ApolloLink {
    request(operation, forward) {
        const observableResult = forward(operation);
        return new apollo_link_1.Observable((observer) => {
            observableResult.subscribe({
                next(x) {
                    const response = operation.getContext().response;
                    const newToken = response.headers.get('authorization');
                    if (newToken) {
                        auth.setAuthToken(newToken);
                    }
                    observer.next(x);
                },
                complete() {
                    observer.complete();
                },
                error(err) {
                    // intercetto gli errori per mancata / scaduta autenticazione
                    if (err.response && err.response.status === 401) {
                        (0, tracking_1.track)({
                            ...track_1.authTrackOverride,
                            action: { type: 'auth_expired' },
                        });
                        try {
                            (0, renewModal_1.openRenewModal)({}).then((loginResult) => {
                                if (loginResult) {
                                    operation.setContext((context) => ({
                                        ...context,
                                        headers: {
                                            ...context.headers,
                                            authorization: (0, auth_1.getValidToken)(),
                                        },
                                    }));
                                    forward(operation).subscribe({
                                        next(x) {
                                            observer.next(x);
                                        },
                                        complete() {
                                            observer.complete();
                                        },
                                        error(e) {
                                            observer.error(e);
                                        },
                                    });
                                }
                            }, (asd) => {
                                observer.error(asd);
                            });
                        }
                        catch (e) {
                            observer.error(e);
                        }
                    }
                    else {
                        observer.error(err);
                    }
                },
            });
        });
    }
};
exports.RenewLink = RenewLink;
//# sourceMappingURL=RenewLink.js.map